import { render } from "./HsButton.vue?vue&type=template&id=11096c98&scoped=true"
import script from "./HsButton.vue?vue&type=script&lang=js"
export * from "./HsButton.vue?vue&type=script&lang=js"

import "./HsButton.vue?vue&type=style&index=0&id=11096c98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11096c98"]])

export default __exports__